import { Component, OnInit, HostBinding, Input, Output, EventEmitter, ViewChild, TemplateRef, ChangeDetectorRef, Optional, Inject, LOCALE_ID } from '@angular/core';
import { TypeConverter } from '@farris/ide-property-panel';
import { CallActivitySubProcess } from './call-activity-sub-process.entity';
import { MessagerService } from '@farris/ui-messager';
import { ProcessDeUtil } from '../../domain/process-de-util';
import { HttpService } from '@ecp-caf/caf-common';
import { Observable } from 'rxjs';
import { ProcessDesignerUIState } from '../../app/process-designer.uistate';
import { ExpressionService, InjectedType, VarEntity } from '@gsp-svc/expression';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';

@Component({
  selector: 'lib-call-activity-sub-process',
  templateUrl: './call-activity-sub-process.component.html',
  styleUrls: ['./call-activity-sub-process.component.scss'],
  providers: [
     WfLocalePipe,
  ]
})
export class CallActivitySubProcessComponent implements OnInit {
  @HostBinding('class')
  cls = 'farris-main-area flex-column';

  @Input() set value(v: CallActivitySubProcess) {
    if (v) {
      this.callActivitySubProcess = v;
      this.getProcessDefKey(this.callActivitySubProcess.calledElement);
      this.getFlowForm(this.callActivitySubProcess.calledBizDefKey);
    }
  }
  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();

  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;
  modalConfig = {
    title: this.localePipe.transform("component.subProcess.subProcessOpt"),
    width: 500,
    height: 380,
    showButtons: true
  };

  callActivitySubProcess: CallActivitySubProcess = new CallActivitySubProcess();

  groupIcon = '<i class="f-icon f-icon-lookup"></i>';
  constructor(
    private message: MessagerService,
    private util: ProcessDeUtil,
    private http: HttpService,
    private designerState: ProcessDesignerUIState,
    private expr: ExpressionService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
   }

  ngOnInit() {
  }


  clickOK() {
    if (this.validator()) {
      const object = { value: this.callActivitySubProcess, parameters: null };
      this.submitModal.emit(object);
    }
  }

  clickCancel() {
    this.closeModal.emit();
  }

  processConfirm(args: any) {
    if (args) {
      this.callActivitySubProcess.calledElement = args.procDefKey;
      this.callActivitySubProcess.calledElementName = args.name;
    }
  }
  clearProcessDef(args: any) {
    this.callActivitySubProcess.calledElement = '';
    this.callActivitySubProcess.calledElementName = '';
  }

  flowFormConfirm(args: any) {
    if (args) {
      this.callActivitySubProcess.calledBizDefKey = args.id;
      this.callActivitySubProcess.calledBizDefName = args.name;
    }
  }
  clearFlowForm(args: any) {
    this.callActivitySubProcess.calledBizDefKey = '';
    this.callActivitySubProcess.calledBizDefName = '';
  }

  setBizDataId() {
    this.showExprHelp();
  }

  private showExprHelp() {
    let context = new Array<VarEntity>();
    // if(this.expr.exprEntity.contextEntities.find(x => x.key === 'CurrentLanguage')) {
    //   context.push(this.expr.exprEntity.contextEntities.find(x => x.key === 'CurrentLanguage'));
    // }
    // this.expr.clearContext();
    if (this.designerState.schemas.length > 0) {
      for (const schema of this.designerState.schemas) {
        this.expr.addSchema('Schema', schema);
      }
      if (this.designerState.schemas[0].entityTypes && this.designerState.schemas[0].entityTypes.length > 0) {
        const entityType = this.designerState.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    context = this.designerState.addContext(context);
    if (this.designerState.subActivityContext.length > 0) {
      for (const variable of this.designerState.subActivityContext) {
        context.push(variable);
        // this.expr.addContext(variable);
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }
    this.expr.addExpressionText(this.callActivitySubProcess.bizDataId);
    this.expr.buildExpression().then((expressioninfo: string) => {
      this.callActivitySubProcess.bizDataId = expressioninfo;
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }

  valueChange(bool: boolean) {
    if (bool) {
      this.callActivitySubProcess.bizDataId = null;
    }
  }

  private validator(): boolean {
    if (!this.callActivitySubProcess.inheritBizDataId && !this.callActivitySubProcess.bizDataId) {
      this.message.warning(this.localePipe.transform("component.subProcess.inheritBizDataId"));
      return false;
    }
    return true;
  }

  private getProcessDefKey(key: string){
    let url = this.util.getProcessDefinitionWebApi();
    if (key) {
      url += `/procDefKey/${key}`;
      this.http.get(url).subscribe((re: any) => {
        this.callActivitySubProcess.calledElementName = re.name;
      });
    }
  }
  private getFlowForm(id: string) {
    let url = this.util.getFlowFormWebApi();
    if (id) {
      url += `/${id}`;
      this.http.get(url).subscribe((re: any) => {
        this.callActivitySubProcess.calledBizDefName = re.name;
      });
    }
  }
}


export class CallActivitySubProcessConverter implements TypeConverter {
  constructor(
    private localePipe: WfLocalePipe
  ) { }

  convertTo(data: any): string {
    if (data && (data.calledBizDefKey || data.calledElement)) {
      return this.localePipe.transform("component.subProcess.set");
    }
    return this.localePipe.transform("component.subProcess.notSet");
  }
}
